<template>
  <header class="app-header navbar">
    <vue-progress-bar></vue-progress-bar>
    <button
      class="navbar-toggler mobile-sidebar-toggler d-lg-none"
      type="button"
      @click="mobileSidebarToggle"
    >&#9776;</button>
    <b-link class="navbar-brand" to="#"></b-link>
    <button
      class="navbar-toggler sidebar-toggler d-md-down-none mr-auto"
      type="button"
      @click="sidebarMinimize"
    >&#9776;</button>
    <div class="d-none d-lg-block" style="align-items-left">
      <!-- <img src='static\img\logo.png' height="30px" width="90px"> -->
      <b>KANTOR PELAYANAN UTAMA BEA DAN CUKAI TIPE B BATAM</b>
      <br />
      <font
        style="font-size: 12px;"
      >TELEPON (0778) 458818, 458263; FAKSIMILI (0778) 458149;SURAT ELEKTRONIK kpubcbatam@kemenkeu.go.id</font>
      <!-- <font style="font-size: 8px;"> <br> JALAN KUDA LAUT, BATU AMPAR, BATAM 29432 <br>
      TELEPON (0778) 458818, 458263; FAKSIMILI (0778) 458149; SITUS bcbatam.beacukai.go.id; SURAT ELEKTRONIK kpubc.batam@kemenkeu.go.id
      </font>-->
    </div>
    <b-nav is-nav-bar class="ml-auto">
      <b-nav-item-dropdown right>
        <template slot="button-content">
          <span class="d-md-down-none">{{ user['username'] }}</span>
        </template>
        <b-dropdown-header tag="div" class="text-center">
          <strong>Account</strong>
        </b-dropdown-header>
        <b-dropdown-item @click="profile">
          <i class="fa fa-user"></i> Profile
        </b-dropdown-item>
        <b-dropdown-item @click="changepw">
          <i class="fa fa-shield"></i> Change Password
        </b-dropdown-item>
        <b-dropdown-item @click="logout">
          <i class="fa fa-lock"></i> Logout
        </b-dropdown-item>
      </b-nav-item-dropdown>
      <button
        class="navbar-toggler aside-menu-toggler d-md-down-none"
        type="button"
        @click="asideToggle"
      >&#9776;</button>
    </b-nav>
  </header>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'header',
  data: {
    // user: ''
  },
  created () {
    // this.user = localStorage.getItem('user')
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    logout () {
      this.signOut().then(() => {
        this.$router.push({ path: '/login' })
      })
    },
    ...mapActions({
      signOut: 'auth/logout'
    }),
    changepw () {
      this.$router.push('/changepass')
    },
    profile () {
      this.$router.push('/profile')
    }
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue?eb170462